// biome-ignore-all lint/suspicious/noExplicitAny: ported redux-toolkit conditional-type dispatch logic (e.g. IsAny<T, ...>) requires real `any`, not `unknown`, to distinguish the two at the type level
// biome-ignore-all lint/suspicious/noConfusingVoidType: `void` here is the ported redux-toolkit sentinel meaning "no payload type provided", distinct from `undefined` (see IfVoid in ts-helpers.ts) — replacing with `undefined` would change dispatch semantics
/**
 * taken from https://github.com/reduxjs/redux-toolkit/tree/master/packages/toolkit/src
 */
/**
 * Creates the runtime action creator implementation shared by the overloads above.
 *
 * @param type - The action type to assign to created actions.
 * @param prepareAction - An optional function that prepares payload, metadata, and errors.
 * @returns A callable action creator with type and matching metadata.
 * @throws {Error} When the prepare callback does not return an action object.
 */
export function createAction(type, prepareAction) {
    function actionCreator(...args) {
        // Use the prepare callback when the caller needs custom payload construction.
        if (prepareAction) {
            const prepared = prepareAction(...args);
            // Reject invalid prepare callbacks before reading their action fields.
            if (!prepared) {
                throw new Error('prepareAction did not return an object');
            }
            // Merge optional metadata and error fields into the prepared action.
            return {
                type,
                payload: prepared.payload,
                ...('meta' in prepared && { meta: prepared.meta }),
                ...('error' in prepared && { error: prepared.error }),
            };
        }
        return { type, payload: args[0] };
    }
    actionCreator.toString = () => `${type}`;
    actionCreator.type = type;
    actionCreator.match = (action) => action.type === type;
    return actionCreator;
}
export { actionSuffixDivider, matchActionSuffix, getBaseType, getType } from './utils.js';
//# sourceMappingURL=create-action.js.map